import React, { useState } from "react";
import Inbox from "./Inbox";
import Sent from "./Sent";
interface IPROPS {
  emailDashboardData: any;
  startDate?: string;
  endDate?: string;
  teamId?: string | null;
}

const SalesChartInner: React.FC<IPROPS> = ({
  emailDashboardData,
  startDate,
  endDate,
  teamId,
}) => {
  const [isInbox, setIsInbox] = useState<any>(false);

  const handleSwitchToggle = () => {
    setIsInbox((prevIsInbox) => {
      const newIsInbox = !prevIsInbox;
      return newIsInbox;
    });
  };

  return (
    <div style={{
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
      border: "1px solid #e2e8f0",
      padding: "20px",
    }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        {/* Title and Toggle */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
          <h2
            style={{
              fontWeight: "600",
              color: "#1e293b",
              margin: 0,
            }}
          >
            Email volume
          </h2>

          {/* Toggle Switch */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#f8fafc",
              padding: "6px 12px",
              borderRadius: "8px",
              border: "1px solid #e2e8f0",
            }}
          >
            <span
              style={{
                fontSize: "13px",
                fontWeight: "500",
                color: !isInbox ? "#6366f1" : "#64748b",
                transition: "color 0.2s",
              }}
            >
              Inbox
            </span>
            <label
              style={{
                position: "relative",
                display: "inline-block",
                width: "44px",
                height: "24px",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                onChange={handleSwitchToggle}
                checked={isInbox}
                style={{
                  opacity: 0,
                  width: 0,
                  height: 0,
                }}
              />
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: isInbox ? "#6366f1" : "#cbd5e1",
                  borderRadius: "24px",
                  transition: "background-color 0.3s",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    content: '""',
                    height: "18px",
                    width: "18px",
                    left: isInbox ? "23px" : "3px",
                    bottom: "3px",
                    backgroundColor: "white",
                    borderRadius: "50%",
                    transition: "left 0.3s",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                  }}
                />
              </span>
            </label>
            <span
              style={{
                fontSize: "13px",
                fontWeight: "500",
                color: isInbox ? "#6366f1" : "#64748b",
                transition: "color 0.2s",
              }}
            >
              Sent
            </span>
          </div>
        </div>
      </div>

      {/* Chart Content */}
      <div
        style={{
          minHeight: "450px",
        }}
      >
        {
          isInbox ? (
            <Sent
              intervalData={emailDashboardData}
              startDate={startDate}
              endDate={endDate}
              teamId={teamId}
            />
          ) : (
            <Inbox
              intervalData={emailDashboardData}
              startDate={startDate}
              endDate={endDate}
              teamId={teamId}
            />
          )}
      </div>
    </div>
  );
};

const SalesChart = React.memo(SalesChartInner);

export default SalesChart;